/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ObjectService {
  /** For the first level indicate an empty path **/
  update<L>(path: string, property: string, data: L, content: any) {
    try {
      content = JSON.parse(JSON.stringify(content));

      const properties = path.split('.');
      const dataObject = properties.reduce(
        (prev, curr) => prev && prev[curr],
        content
      );

      if (dataObject) {
        dataObject['relatedLinks'] = data;
      } else {
        content[property] = data;
      }

      return content;
    } catch (e) {
      console.log('The content object is undefined', e);
    }
  }
}
